import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=35c020b7&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=35c020b7&prod&scoped=true&lang=css"
import style1 from "./Item.vue?vue&type=style&index=1&id=35c020b7&prod&lang=css"
import style2 from "./Item.vue?vue&type=style&index=2&id=35c020b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c020b7",
  null
  
)

export default component.exports